<template>
  <div class="contact-page">
    <!-- 联系我们横幅 -->
    <div class="contact-banner">
      <div class="container">
        <h1>联系我们</h1>
        <p>如有任何疑问或建议，请随时与我们联系</p>
      </div>
    </div>

    <!-- 联系信息和留言表单 -->
    <div class="container">
      <div class="contact-wrapper">
        <div class="message-form">
          <h2>留言</h2>
          <p>Message</p>
          <form @submit.prevent="submitMessage">
            <div class="form-group">
              <label for="name">联系人 *</label>
              <input 
                type="text" 
                id="name" 
                v-model="messageForm.name" 
                required 
                placeholder="请输入您的姓名">
            </div>
            
            <div class="form-group">
              <label for="email">电子邮箱 *</label>
              <input 
                type="email" 
                id="email" 
                v-model="messageForm.email" 
                required 
                placeholder="请输入您的邮箱地址">
            </div>
            
            <div class="form-group">
              <label for="content">留言内容 *</label>
              <textarea 
                id="content" 
                v-model="messageForm.content" 
                required 
                placeholder="请输入您的留言内容"
                rows="6"></textarea>
            </div>
            
            <button type="submit" class="submit-btn" :disabled="isSubmitting">
              {{ isSubmitting ? '提交中...' : '提交留言' }}
            </button>
            
            <div v-if="submitMessageText" class="submit-message" :class="{ success: isSubmitSuccess, error: !isSubmitSuccess }">
              {{ submitMessageText }}
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactPage',
  data() {
    return {
      messageForm: {
        name: '',
        email: '',
        content: ''
      },
      isSubmitting: false,
      isSubmitSuccess: false,
      submitMessageText: ''
    }
  },
  methods: {
    submitMessage() {
      // 设置提交状态
      this.isSubmitting = true;
      this.submitMessageText = '';
      
      // 简单验证
      if (!this.messageForm.name || !this.messageForm.email || !this.messageForm.content) {
        this.isSubmitSuccess = false;
        this.submitMessageText = '请填写所有必填字段';
        this.isSubmitting = false;
        return;
      }
      
      // 验证邮箱格式
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.messageForm.email)) {
        this.isSubmitSuccess = false;
        this.submitMessageText = '请输入有效的邮箱地址';
        this.isSubmitting = false;
        return;
      }
      
      // 构造发送到后端的数据
      const mailData = {
        to: 'service@vosdom.com', // 将留言发送到此邮箱
        subject: `来自网站用户 ${this.messageForm.name} 的留言`,
        text: `联系人: ${this.messageForm.name}\n邮箱: ${this.messageForm.email}\n留言内容:\n${this.messageForm.content}`
      };
      
      // 发送POST请求到后端API
      fetch('/api/mail/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(mailData)
      })
      .then(response => {
        if (response.ok) {
          // 提交成功
          this.isSubmitSuccess = true;
          this.submitMessageText = '留言提交成功！我们会尽快与您联系。';
          
          // 清空表单
          this.messageForm.name = '';
          this.messageForm.email = '';
          this.messageForm.content = '';
          
          this.isSubmitting = false;
          
          // 3秒后清除提示信息
          setTimeout(() => {
            this.submitMessageText = '';
          }, 3000);
        }
      })
      .catch(error => {
        // 提交失败
        this.isSubmitSuccess = false;
        this.submitMessageText = '留言提交失败，请稍后再试。';
        console.error('提交错误:', error);
        this.isSubmitting = false;
      });
    }
  }
}
</script>

<style scoped>
.contact-page {
  margin-top: 80px;
}

.contact-banner {
  background: linear-gradient(to right,#0a338c,#0a338c);
  color: white;
  padding: 60px 0;
  text-align: center;
  margin-bottom: 50px;
}

.contact-banner h1 {
  font-size: 2.5rem;
  margin-bottom: 20px;
}

.contact-banner p {
  font-size: 1.2rem;
  opacity: 0.9;
}

.contact-info h2 {
  margin-bottom: 30px;
  font-size: 1.8rem;
  color: #333;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 30px;
}

.contact-item .icon {
  background: #409eff;
  color: white;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  flex-shrink: 0;
}

.contact-item .icon i {
  font-size: 1.2rem;
}

.contact-item .info h3 {
  margin-bottom: 5px;
  font-size: 1.3rem;
  color: #333;
}

.contact-item .info p {
  font-size: 1.1rem;
  color: #666;
}

.message-form {
  flex: 1;
  background: #f8f9fa;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.message-form h2 {
  margin-bottom: 30px;
  font-size: 1.8rem;
  color: #333;
  text-align: center;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background: white;
  font-size: 1rem;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.submit-btn {
  width: 100%;
  padding: 15px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s;
}

.submit-btn:hover:not(:disabled) {
  background: #66b1ff;
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.submit-message {
  margin-top: 20px;
  padding: 15px;
  border-radius: 5px;
  text-align: center;
  font-weight: 500;
}

.submit-message.success {
  background: rgba(46, 204, 113, 0.2);
  border: 1px solid #2ecc71;
  color: #2ecc71;
}

.submit-message.error {
  background: rgba(231, 76, 60, 0.2);
  border: 1px solid #e74c3c;
  color: #e74c3c;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .contact-wrapper {
    flex-direction: column;
  }
  
  .contact-banner h1 {
    font-size: 2rem;
  }
  
  .contact-banner p {
    font-size: 1rem;
  }
  
  .contact-item {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .contact-item .icon {
    margin-right: 0;
    margin-bottom: 15px;
  }
}
</style>